import React from "react";
import { useState, useEffect } from "react";
import { useDimensions } from "../../../Util";
import { useNavigate } from "react-router-dom";
import { updatePaUser } from "../../../UtilComps/Crud";

const PenPunContainer = ({ id,penalty, punishment, incomingUser,bearerToken }) => {

    const { w, h } = useDimensions();
    const [isTransferBtnDisabled,setIsTransferBtnDisabled]=useState(false);
    const [showPracticeDollors,setShowPracticeDollors]=useState(false);
    const [isPenaltyPaid,setIsPenaltyPaid]=useState(false); 
    const [showArrow,setShowArrow]=useState(false); 
    var user = incomingUser;
    const [walletBalance,setWalletBalance]=useState(incomingUser?.walletbalance)
    const [jarBalance,setJarBalance]=useState(incomingUser?.jarbalance);
    const navigate = useNavigate();

    useEffect(() => {
        if(walletBalance<penalty){
            setIsTransferBtnDisabled(true)
            setShowPracticeDollors(true);
        }else{
            setIsPenaltyPaid(false);     
        }
    }, []);

    const showGetPracticeDollors=()=>{
        if(user.walletbalance<=0){
            showGetPracticeDollors(true);
        }
    }

    const getPracticeDollors = ()=>{
        if(user!=null&&user.walletbalance<penalty){
            let u = user;
            u.walletbalance=u.walletbalance+300;
            setWalletBalance(u.walletbalance);
            setIsTransferBtnDisabled(false);
            u = updateUserActivity(u,"300pd"+"-in-"+id);
            setShowPracticeDollors(false);
            user = u;
        }
    }

    const updateUserActivity = (user,activity) =>{
        let userActivity = [];
                userActivity = Array.isArray(user?.activity) ? user.activity : [];
                const newActivityItem = activity;
                userActivity.push(newActivityItem);
        user.activity = userActivity.map(item => String(item));
        return user;
    }

    const styles = {
        youareGuiltyContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        youareGuiltyImage: {
            width: w > h ? 15 * h : 15 * h,
            height: w > h ? 15 * h : 15 * h
        },
        largeTextBold: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(28px,3vw,35px)" : "clamp(28px,3vh,35px)"
        },
        penPunContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: w > h ? 2 * w : 3 * w,
        },
        penHeadingContainer: {
            background: "#FF2E63", //pink
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "7px"
        },
        punHeadingContainer: {
            background: "#00ADB5", //teal
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "7px"
        },
        icon: {
            width: w > h ? 5 * h : 5 * h,
            height: w > h ? 5 * h : 5 * h,
        },
        circularIcon: {
            width: w > h ? 5 * h : 5 * h,
            height: w > h ? 5 * h : 5 * h,
            borderRadius: "50%"
        },
        mediumTextBold: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(20px,2vw,25px)" : "clamp(20px,2vh,25px)"
        },
        mediumTextNormal: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(20px,2vw,25px)" : "clamp(20px,2vh,25px)"
        },
        smallTextBold: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(12px,1.25vw,15px)" : "clamp(12px,1.25vh,15px)"
        },
        smallTextNormal: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(14px,1.5vw,17px)" : "clamp(14px,1.5vh,17px)"
        },
        xlargeTextBold: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(38px,4vw,50px)" : "clamp(38px,4vh,50px)"
        },
        transferContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            marginTop: 3 * h,
            gap: "7px"
        },
        btnPay: {
            padding: "7px",
            background: "#F9ED69",
            color: "#222831",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 1.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer",
            fontWeight:600
        },
        btnLater: {
            padding: "7px",
            background: "#393E46",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 1.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer"
        },
        btnDisabled: {
            padding: "7px",
            background: "#9DB2BF",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 2 * h,
            fontFamily: "Candal",
            marginInline: "5px",
            cursor: "not-allowed"
        },
        loginContainer: {
            marginTop: 3 * h
        }

    }

    const transferClicked = () => {
        setIsTransferBtnDisabled(true);
        setShowArrow(true);
        setWalletBalance(walletBalance-penalty);
        setJarBalance(jarBalance+penalty);
        setIsPenaltyPaid(true);
        user.walletbalance=walletBalance-penalty;
        user.jarbalance=jarBalance+penalty;
        user = updateUserActivity(user,"pen-paid")
        user.clockowe=user.clockowe+punishment;
    }

    const explorePunishments = () => {
        atTheEnd();
        navigate("/alternates");       
    };

    const atTheEnd = async ()=>{
        const response = await updatePaUser({user:user,bearerToken:bearerToken})
        sessionStorage.setItem("proaddictive-user",JSON.stringify(response.user));
        localStorage.setItem("proaddictive-user",JSON.stringify(response.user));
    }

    return <div id="pen-pun-container">
        <div id="you-are-guilty" style={styles.youareGuiltyContainer}>
            <img src={`/images/youareguilty.png`} style={styles.youareGuiltyImage} alt="Description" />
            <p style={styles.largeTextBold}>You're Guilty</p>
        </div>
        <div id="pen-pun" style={styles.penPunContainer}>
            <div id="pen">
                <div id="pen-heading" style={styles.penHeadingContainer}>
                    <img src={`/images/penaltycircularicon.png`} style={styles.circularIcon} alt="Description" />
                    <p style={styles.mediumTextBold}>PENALTY</p>
                </div>
                <p style={styles.xlargeTextBold}>${penalty}</p>
            </div>
            <div id="pun">
                <div id="pun-heading" style={styles.punHeadingContainer}>
                    <img src={`/images/circularclock.png`} style={styles.circularIcon} alt="Description" />
                    <p style={styles.mediumTextBold}>PUNISHMENT</p>
                </div>
                <p style={styles.xlargeTextBold}>{punishment}Min</p>
            </div>
        </div>
        <div id="transfer" style={styles.transferContainer}>
            <p style={styles.mediumTextBold}>${walletBalance}</p>
            <img src={`/images/wallet.png`} style={styles.icon} alt="Description" />
            {
                showArrow?(
                    <img src={`/images/arrow.png`} style={styles.icon} alt="Description" />
                ):(
                    <button id="btn-transfer" style={isTransferBtnDisabled ? styles.btnDisabled : styles.btnPay} onClick={transferClicked} disabled={isTransferBtnDisabled}>DROP</button>
                )
            }
            <img src={`/images/jar.png`} style={styles.icon} alt="Description" />
            <p style={styles.mediumTextBold}>${jarBalance}</p>
        </div>
        <div id="get-practice-dollors" style={styles.transferContainer}>
            {
              showPracticeDollors?(
                <button id="btn-transfer" style={styles.btnPay} onClick={getPracticeDollors}>Get Practice Dollors</button>
                ):(
                <div>
                    <button id="btn-transfer" style={!isPenaltyPaid ? styles.btnDisabled : styles.btnPay} onClick={explorePunishments} disabled={!isPenaltyPaid}>Explore Punishments</button>
                </div>
                )   
            }
        </div>
    </div >
}

export default PenPunContainer;